var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2654({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3811 17.0525C35.3811 28.01 31.52 27.0974 17.6905 27.0974C3.86103 27.0974 0 27.7994 0 17.0525C0 7.86533 7.92032 0 17.6905 0C27.4608 0 35.3811 7.86533 35.3811 17.0525Z",
    fill: "url(#paint0_linear_1780_14238)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3811 17.0525C35.3811 28.01 31.52 49 17.6905 49C3.86103 49 0 27.7994 0 17.0525C0 7.86533 7.92032 0 17.6905 0C27.4608 0 35.3811 7.86533 35.3811 17.0525Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3811 17.0528C35.3811 28.0102 31.52 49.0002 17.6905 49.0002C3.86103 49.0002 0 27.7996 0 17.0528C0 7.86555 7.92032 26.7466 17.6905 26.7466C27.4608 26.7466 35.3811 7.86555 35.3811 17.0528Z",
    fill: "url(#paint1_linear_1780_14238)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89357 5.70236C12.842 4.98605 16.1429 4.75666 17.7597 4.74097V16.3895H12.5703C10.3545 16.3895 8.14976 16.0782 6.02063 15.4648C5.71058 15.3754 5.51861 15.066 5.57677 14.7486L5.58049 14.7283C5.83971 13.3139 6.20724 11.3085 6.42937 9.64227C6.68195 7.74768 8.03623 6.15358 9.89357 5.70236Z",
    fill: "#2B2D33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.093 6.33322C12.946 5.66683 16.1767 5.45535 17.7591 5.44116V15.753H13.1015C10.8075 15.753 8.52341 15.4542 6.30668 14.8642C6.16051 14.8253 6.06953 14.68 6.09892 14.5316C6.34795 13.2745 6.73443 11.3559 6.96186 9.78002C7.20386 8.10317 8.44315 6.71857 10.093 6.33322Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.626 5.70236C22.6775 4.98605 19.3767 4.75666 17.7598 4.74097V16.3895H22.9493C25.165 16.3895 27.3698 16.0782 29.4989 15.4648C29.809 15.3754 30.0009 15.066 29.9428 14.7486L29.939 14.7283C29.6798 13.3139 29.3123 11.3085 29.0902 9.64227C28.8376 7.74768 27.4833 6.15358 25.626 5.70236Z",
    fill: "#2B2D33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4266 6.33322C22.5735 5.66683 19.3428 5.45535 17.7604 5.44116V15.753H22.4181C24.712 15.753 26.9961 15.4542 29.2128 14.8642C29.359 14.8253 29.45 14.68 29.4206 14.5316C29.1716 13.2745 28.7851 11.3559 28.5577 9.78002C28.3157 8.10317 27.0764 6.71857 25.4266 6.33322Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1780_14238)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.6679,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6679,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6679,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6679,
    cy: 11.0424,
    r: 2.80075,
    fill: "#50D6E7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1780_14238)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.2168,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.2168,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.2168,
    cy: 11.0424,
    r: 2.80075,
    fill: "#C91414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.2168,
    cy: 11.0424,
    r: 2.80075,
    fill: "#50D6E7"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 23.3333C12.1301 23.3333 7.77734 27.3044 7.77734 32.203C7.77734 36.6106 11.3011 40.2672 15.9187 40.9561V45.111L22.4344 39.8469C25.2997 38.3039 27.2218 35.4582 27.2218 32.203C27.2218 27.3044 22.869 23.3333 17.4996 23.3333Z",
    fill: "#1E203D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 35.7534L19.9034 33.2003L14 30.5743V27L24.1111 31.7414V34.6592L14 39.4007V35.7534Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1780_14238",
    x: 7.86719,
    y: 6.2417,
    width: 9.60156,
    height: 9.60156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1780_14238"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1780_14238",
    x: 17.416,
    y: 6.2417,
    width: 9.60156,
    height: 9.60156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1780_14238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1780_14238",
    x1: 17.6905,
    y1: 0,
    x2: 17.6905,
    y2: 27.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1780_14238",
    x1: 17.6905,
    y1: 8.94455,
    x2: 17.6905,
    y2: 49.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2654);
export default __webpack_public_path__ + "static/media/Frame 2654.8247d663f466353ffb594dcb27f19988.svg";
export { ForwardRef as ReactComponent };